import { render, staticRenderFns } from "./consultationTitle.vue?vue&type=template&id=1810858e&scoped=true"
import script from "./consultationTitle.vue?vue&type=script&lang=js"
export * from "./consultationTitle.vue?vue&type=script&lang=js"
import style0 from "./consultationTitle.vue?vue&type=style&index=0&id=1810858e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1810858e",
  null
  
)

export default component.exports